import { render, staticRenderFns } from "./ChannelsTable.vue?vue&type=template&id=32d28934&scoped=true"
import script from "./ChannelsTable.vue?vue&type=script&lang=js"
export * from "./ChannelsTable.vue?vue&type=script&lang=js"
import style0 from "./ChannelsTable.vue?vue&type=style&index=0&id=32d28934&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d28934",
  null
  
)

export default component.exports